import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { observer } from "mobx-react";
import { useStore } from "../../../contexts/StoreProvider";
import { Button, Modal } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import { PaymentCardValidationSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import Label from "../../../shared-components/Label/Label";
import FormikFormInput from "../../../shared-components/FormikFormHandlers/FormikFormInput";
import FormikDateFieldMUI from "../../../shared-components/FormikFormHandlers/FormikDateFieldMUI";
import { FormattedMessage } from "react-intl";
import LoaderButton from "../../../shared-components/Button/LoaderButton";
import { initialState as paymentCardInitialState } from "../../../core/initial-state/payment-card-state";
import IPaymentCard from "../../../models/Form/IPaymentCard";
import FormikFormCheckBox from "../../../shared-components/FormikFormHandlers/FormikFormCheckBox";
import { userInfo } from "os";
import { PhoneNumberType, UserType } from "../../../constants/enum";
import FormikPhoneInput from "../../../shared-components/FormikFormHandlers/FormikPhoneInput";
import FormikFormSelect from "../../../shared-components/FormikFormHandlers/FormikFormSelect";
import { forIn } from "lodash";

interface IProps {
  modalClosed: () => void;
  isLoading: boolean;
  submitHandler: (values: IPaymentCard) => void;
  error: string;
  status: string;
  threeDSRedirectURL: string;
}

interface IOptions {
    id: string;
    value: string;
}

const phoneNumberOptions:Array<IOptions>  = [];
forIn(PhoneNumberType, (value, key) => {
    if ((Number(value))) 
        phoneNumberOptions.push({
            id: value.toString(),
            value: `PhoneType_${key}`
        })
});

const PaymentModal = (props: IProps) => {
    const { authStore } = useStore();
    const { userType, getUserType } = authStore;
    
    // If a redirect URL is found, redirect the user
    useEffect(() => {
        if (props.threeDSRedirectURL) {
            window.location.href = props.threeDSRedirectURL;
        }
    }, [props.threeDSRedirectURL]);

  return (
    <>
        <Modal show={true} centered
                onHide={props.modalClosed}
                backdrop="static"
                scrollable={true}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FormattedMessage id='enter_card_details'/>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={paymentCardInitialState}
                        validationSchema={PaymentCardValidationSchema}
                        enableReinitialize
                        validateOnBlur={false}
                        onSubmit={ async (values: IPaymentCard) => {
                            props.submitHandler(values);
                        }}
                    >
                        {({ values, errors, handleChange, handleBlur }) => (
                            <>
                            <Form id="addEditCouponForm" className="modal-form">
                                <div className="">
                                    <div className="form-group ">
                                        <Label
                                            required={true}
                                            className="fw-bold"
                                            label="card_number"
                                            htmlFor="CardNumber" />
                                        <Field
                                            data-testid="CardNumber"
                                            className="form-control"
                                            name="CardNumber"
                                            maxLength={16}
                                            type="number"
                                            invalidcharacter={[" "]}
                                            placeholder="card_number"
                                            as={FormikFormInput} />
                                    </div>
                                    <div className="form-group ">
                                        <Label
                                            required={true}
                                            className="fw-bold"
                                            label="card_holder_name"
                                            htmlFor="CardHolderName" />
                                        <Field
                                            data-testid="CardHolderName"
                                            className="form-control"
                                            name="CardHolderName"
                                            type="text"
                                            placeholder="card_holder_name"
                                            as={FormikFormInput} />
                                    </div>
                                    <div className="form-group ">
                                        <Label
                                            required={true}
                                            className="fw-bold"
                                            label="card_cvv"
                                            htmlFor="CVV" />
                                        <Field
                                            data-testid="CVV"
                                            className="form-control"
                                            name="CVV"
                                            type="text"
                                            maxLength={3}
                                            minLength={3}
                                            invalidcharacter={[" "]}
                                            placeholder="card_cvv"
                                            as={FormikFormInput} />
                                    </div>
                                    <div className="form-group ">
                                        <Label
                                            required={true}
                                            className="fw-bold"
                                            label="expiry_date"
                                            htmlFor="ExpiryDate"
                                        />
                                        <Field
                                            data-testid="ExpiryDate"
                                            className="form-control"
                                            name="ExpiryDate"
                                            min={Date.now()}
                                            cardExpiryformat={true}
                                            as={FormikDateFieldMUI}
                                        />
                                    </div>
                                    <div className="form-group ">
                                        <Label
                                            required={true}
                                            className="fw-bold"
                                            label="card_holder_email"
                                            htmlFor="CardHolderEmail" />
                                        <Field
                                            data-testid="CardHolderEmail"
                                            className="form-control"
                                            name="CardHolderEmail"
                                            validcharacter={[
                                                "-",
                                                "_",
                                                "[",
                                                "]",
                                                "(",
                                                ")",
                                                ":",
                                                "#",
                                                "@",
                                                ".",
                                            ]}
                                            invalidcharacter={[" "]}
                                            placeholder="mail"
                                            as={FormikFormInput} />
                                    </div>
                                    <div className="form-group row">
                                        <Label
                                            showOptionalLabelIfNotRequiredField={true}
                                            className="fw-bold"
                                            label="card_holder_phone"
                                            htmlFor="CardHolderPhone" />
                                        <div className="col">
                                            <Field
                                                data-testid="PhoneType"
                                                className="form-control"
                                                name="CardHolderPhoneType"
                                                as={FormikFormSelect}
                                                options={phoneNumberOptions}
                                            />
                                        </div>
                                        <div className="col-9">
                                            <Field
                                                data-testid="CardHolderPhone"
                                                className="form-control"
                                                name="CardHolderPhone"
                                                callingCode="CardHolderPhoneCode"
                                                // placeholder="jondoe@example.com"
                                                as={FormikPhoneInput} />
                                        </div>
                                    </div>
                                    {/* { userType === UserType.Admin || getUserType === UserType.Admin &&
                                        <div className="form-group">
                                            <Label
                                                required={true}
                                                label="3D Secure"
                                                htmlFor="Is3DSecure"
                                                className="me-3"
                                            />
                                            <span className="form-switch">
                                                <Field
                                                    data-testid="test3DSecure"
                                                    className="form-check-input"
                                                    role="switch"
                                                    name="Is3DSecure"
                                                    type="checkbox"
                                                    id="inlineFormCheck"
                                                    as={FormikFormCheckBox}
                                                />
                                            </span>
                                        </div>
                                    } */}
                                </div>

                            {!props.isLoading && props.error !== "" &&
                                <span className="text-danger"><b>Error:</b> {props.error}</span>
                            }
                            </Form>
                            </>
                        )}
                    </Formik>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-end ">
                        <Button
                            data-testid="Cancel"
                            variant="secondary"
                            onClick={props.modalClosed}
                            disabled={props.isLoading}
                            className="btnOkSize me-2">
                            <FormattedMessage id="button_cancel" />
                        </Button>
                        <LoaderButton
                            type="submit"
                            id="RegisterButton"
                            form="addEditCouponForm"
                            isLoading={props.isLoading}
                            // className="btnOkSize"
                            text="pay_now"
                        />
                    </div>
                </Modal.Footer>
            </Modal>
    </>
  );
};

export default observer(PaymentModal);
